export interface SendBirdChatChannel {
    channelUrl?: string;
    userId?: string;
    nickName?: string;
}
